import { getGlobals } from '../globals/globals';

// Not typing these, since once globals are typed they will auto be typed
const { deployEnv: env } = getGlobals();
const isDev = env.development;
const isProd = env.production || env.sandbox;
const isStage = env.staging;
const isTest = process.env.NODE_ENV === 'test';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const logDevErrorToConsole = (error: any): void => {
  const styles = `
    background-color: #b80000;
    color: #fff;
    font: bold 30px;
    line-height: 1.2;
    padding: 20px 15px;
  `;
  const log = `FALLBACK PREVENTED IN DEV MODE -- ERROR: ${error}`;
  console.log(`%c${log}`, styles); // eslint-disable-line no-console
};

export { isDev, isProd, isStage, isTest, logDevErrorToConsole };
